module.exports = __webpack_public_path__ + "img/green-rectangle-table-8.7bcbf6ab.png";